import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBankingUserLoginV2Mutation } from "generated/generated-models";
import { useNavigate } from "react-router-dom";
import LoginHeader from "./LoginHeader";
import Input from "app/components/Input";
import { nameof } from "core/util/nameof";
import Form from "app/components/Form";
import { Formik } from "formik";
import { Validate, } from "./EnterNewPasswordValidator";
import LoginErrorMessage from "./LoginErrorMessage";
import LoginIcon from "@mui/icons-material/Login";
import { LoadingButton } from "@mui/lab";
import { Paper, Button } from "@mui/material";
const initialFormValues = {
    password: "",
    confirmPassword: "",
};
const EnterNewPassword = ({ username, password, twoFactorToken, reset, }) => {
    const navigate = useNavigate();
    const [userLogin, { loading, data, error }] = useBankingUserLoginV2Mutation();
    const handleSubmit = async (values) => {
        await userLogin({
            variables: {
                input: {
                    Password: password,
                    Username: username,
                    TwoFactorToken: twoFactorToken,
                    NewPassword: values.password,
                },
            },
            context: { headers: { "X-Interfi-RequestType": "Anonymous" } },
        });
    };
    if (data?.loginV2?.AuthSucceeded) {
        navigate("/");
    }
    return (_jsx("div", { children: _jsx("div", { id: "login-screen", children: _jsxs(Paper, { sx: { p: 10, borderRadius: 3 }, variant: "elevation", elevation: 24, className: "login-screen set-password", children: [_jsx(LoginHeader, { heading: "Set New Password", subHeading: "Please set a new password for your account. " }), _jsx(LoginErrorMessage, { isUsingGoogleAuth: data?.loginV2?.IsUsingGoogleAuth, loginError: error, loginResponse: data }), _jsx(Formik, { initialValues: {
                            ...initialFormValues,
                        }, onSubmit: (values) => {
                            handleSubmit(values);
                        }, validationSchema: Validate(), children: () => {
                            return (_jsxs(Form, { className: "prelogin-form", children: [_jsx(Input, { name: nameof("password"), type: "password", label: "New Password" }), _jsx(Input, { name: nameof("confirmPassword"), type: "password", label: "Confirm New Password" }), _jsxs("div", { className: "form-group button-row", children: [_jsx(Button, { role: "secondary", id: "cancel", sx: { width: 150, p: 1.5, mt: 1 }, variant: "outlined", onClick: reset, disabled: loading, children: "Cancel" }), _jsx(LoadingButton, { type: "submit", id: "submit", sx: { width: 150, p: 1.5, mt: 1 }, endIcon: _jsx(LoginIcon, {}), loading: loading, loadingPosition: "end", variant: "contained", children: "Login" })] })] }));
                        } })] }) }) }));
};
export default EnterNewPassword;
